import { takeLatest, put, call } from 'redux-saga/effects';

import { listTransferenciaAnimal } from '../service';
import {
  TABLE_TRANSFERENCIA_ANIMAL,
  TABLE_TRANSFERENCIA_ANIMAL_PENDING,
  TABLE_TRANSFERENCIA_ANIMAL_SUCCESS,
  TABLE_TRANSFERENCIA_ANIMAL_FAILURE
} from '../actionTypes';

function* sagaListTransferenciaAnimal(action) {
  yield put({ type: TABLE_TRANSFERENCIA_ANIMAL_PENDING })

  try {
    const table = yield call(listTransferenciaAnimal, action.args)
    yield put({ type: TABLE_TRANSFERENCIA_ANIMAL_SUCCESS, table: table })
  } catch (error) {
    yield put({ type: TABLE_TRANSFERENCIA_ANIMAL_FAILURE })
  }
}

export default function* watchListTransferenciaAnimal() {
  yield takeLatest(TABLE_TRANSFERENCIA_ANIMAL, sagaListTransferenciaAnimal)
}